// @import dependencies
import React, {Component, CSSProperties} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ModalReferenceFormModuleLayout} from 'app_components/modules/admin/landings/modalReferenceForm'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
import { IReferences } from 'app_types/admin/landings/landingTypes'
// @end

// @ADD Component types
interface IModalReferenceFormModuleProps {
  open: boolean
  source: string
  editData?: IReferences
  className?: string
  style?: CSSProperties
  id?: string
  onClose?: (status?: boolean) => any
}
interface IModalReferenceFormModuleState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ModalReferenceFormModule extends Component<IModalReferenceFormModuleProps, IModalReferenceFormModuleState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IModalReferenceFormModuleProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <ModalReferenceFormModuleLayout
        {...this.props}
      />
    )
  }
}

export default connect(mapStatesToProps)(ModalReferenceFormModule)
